import CONFIG from '@/configs/config'
import { Post, Get } from '@/utils/RequestService'

var apiUrl = CONFIG.API_URL
var service = {
  login: (data) => Post(`${apiUrl}auth/login`, data),
  register: (data) => Post(`${apiUrl}auth/register`, data),
  verifyEmail: (code) => Get(`${apiUrl}auth/verify-email/${code}`),
  resendVerifyEmail: (data) => Post(`${apiUrl}auth/resend-verify-email`, data),
  forgotPassword: (data) => Post(`${apiUrl}auth/forgot-password`, data),
  resetPassword: (data) => Post(`${apiUrl}auth/reset-password`, data),
  forgotOTP: (data) => Post(`${apiUrl}auth/forgot-totp`, data),
  removeOTP: (data) => Post(`${apiUrl}auth/remove-totp`, data)
}

export default service
